import { useEffect, useState } from "react";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Bento } from "../components/Bento";
import { Catalog } from "../components/Catalog";
import { HowItWorks } from "../components/HowItWorks";
import { Reviews } from "../components/Reviews";
import { Faq } from "../components/Faq";
import { Footer } from "../components/Footer";
import { CheckoutDialog } from "../components/CheckoutDialog";
import { SmoothScroll } from "../components/SmoothScroll";
import { DropCountdown } from "../components/DropCountdown";
import { api } from "../lib/api";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [buying, setBuying] = useState(null);

  useEffect(() => {
    api.get("/products")
      .then((r) => setProducts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
    api.get("/settings").then((r) => setSettings(r.data ?? null)).catch(() => setSettings(null));
  }, []);

  const inStock = products.filter((p) => (p?.stock ?? 0) > 0);
  const maxRank = products.reduce((m, p) => Math.max(m, p?.rank ?? 0), 0);

  return (
    <div className="grain min-h-screen bg-[#07070b]">
      <SmoothScroll />
      <Nav />
      <main>
        <Hero liveCount={inStock.reduce((s, p) => s + (p.stock ?? 0), 0)} />
        <Marquee />
        <DropCountdown settings={settings} />
        <Bento maxRank={maxRank} count={inStock.length} />
        <Catalog products={products} loading={loading} onBuy={setBuying} deliveryTime={settings?.delivery_time ?? ""} />
        <HowItWorks />
        <Reviews />
        <Faq />
      </main>
      <Footer settings={settings} />
      <CheckoutDialog product={buying} onClose={() => setBuying(null)} deliveryTime={settings?.delivery_time ?? ""} />
    </div>
  );
}
